/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {
    SimpleReelModel,
    SimpleReelModelDelegate,
    SimpleReelModelState,
} from "../../core/reel/simplereel/SimpleReelModel";
import {BrickSnake2000} from "../BrickSnake2000";
import {LayersSet} from "./LayersSet";
import {BrickSnake2000Symbol} from "./symbols/BrickSnake2000Symbol";
import {BrickSnake2000GameAssets} from "../BrickSnake2000GameAssets";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {LoopableList} from "../utils/LoopableList";
import {reelPosition} from "../server/BrickSnake2000Model";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";

export class BrickSnake2000BaseGameReelView extends PIXI.Container implements StageLayer, SimpleReelModelDelegate{

    private _reelModels:SimpleReelModel[];
    public layers:LayersSet;

    private symbolWidth:number = 118;
    private symbolHeight:number = 118;
    public static stepDuration:number = 0.04;
    // pixi sucks lol
    private maxWinAnticipation:TimelineSprite;
    private maxWinAnticipation2:TimelineSprite;

    private symbolMask:PIXI.Graphics;
    private xBetDisabledRow:BrickSnake2000Symbol[];
    private xBetReelHighlight:PIXI.Sprite;
    private xBetReelFrame:PIXI.Sprite;

    private wallExplosion:PIXI.spine.Spine;
    private wallExplosion2:PIXI.spine.Spine;
    private explosions:LoopableList<string>;

    private static BASE_GAME_REEL_1:string[] = ["XW","L1","L2","L3","L4","M1","M2","M3","M4"];
    private static FREE_SPINS_REEL:string[] = ["XW", "L1","L2","L3","L4","M1","W","M2","M3","M4"];
    private static DEFAULT_REEL_SET:string[] = ["XW","L1","L2","L3","L4","M1","M2","M3","M4", "S"];
    private static XBET_REEL_SET:string[] = ["X","X","X","X","X","X","X","S"];

    constructor() {
        super();
        this.name = "BrickSnake2000BaseGameReelView";
        this.layers = new LayersSet();

        this.init();
    }

    get reelModels():SimpleReelModel[] {
        return this._reelModels;
    }

    private init() {

        //this.layers.maskedNormal = new PIXI.Container();
        //this._symbolContainer.position.set(0, 164);
        this.xBetReelHighlight = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.XBET_REEL_HIGHLIGHT)[0]);
        this.xBetReelHighlight.anchor.set(0.5, 0.5);
        this.xBetReelHighlight.position.set(65 + this.symbolWidth * 1.5, 297);
        this.xBetReelHighlight.alpha = 0;
        this.addChild(this.xBetReelHighlight);

        this.layers.maskedNormal.x = 65;
        this.layers.maskedNormal.y = 150;
        this.addChild(this.layers.maskedNormal);
        this.layers.maskedM1.x = 65;
        this.layers.maskedM1.y = 150;
        this.addChild(this.layers.maskedM1);
        this.layers.maskedScatters.x = 65;
        this.layers.maskedScatters.y = 150;
        this.addChild(this.layers.maskedScatters);
        this.layers.maskedOver.x = 65;
        this.layers.maskedOver.y = 150;
        this.addChild(this.layers.maskedOver);
        this.layers.win.x = 65;
        this.layers.win.y = 150;
        this.addChild(this.layers.maskedWinCap);
        this.layers.maskedWinCap.x = 65;
        this.layers.maskedWinCap.y = 150;
        this.addChild(this.layers.win);

        this.xBetDisabledRow = [0,1,2,3,4].map((reelID) => this.createSymbol("XB", SimpleReelModelState.IDLE, reelID, 4));
        this.xBetDisabledRow.forEach((sym, index) => {
            sym.position.x = 65 + this.symbolWidth * (index + 0.5);
            sym.position.y = 150 + this.symbolHeight * 4;
            sym.alpha = 0;
            this.addChild(sym);
        });


        this._reelModels = [];
        for (let i:number = 0; i < 5; i++){
            const reel = new SimpleReelModel(i, this, true);
            reel.setReelSet(i == 0
                            ? BrickSnake2000BaseGameReelView.BASE_GAME_REEL_1
                            : BrickSnake2000BaseGameReelView.DEFAULT_REEL_SET);
            reel.stepDuration = BrickSnake2000BaseGameReelView.stepDuration;
            reel.stepSize = this.symbolHeight;
            if (BrickSnake2000.model.isRestore && (BrickSnake2000.model.data.mode == GameMode.FREESPIN ||
                                                   BrickSnake2000.model.data.mode == GameMode.FREESPIN_SUPER ))
                reel.init(BrickSnake2000.model.initData.beforeFreespinsArea[i].concat());
            else
                reel.init(BrickSnake2000.model.data.reels[i].concat());
            this._reelModels.push(reel);
        }

        this.xBetReelFrame = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.XBET_REEL_FRAME)[0]);
        this.xBetReelFrame.anchor.set(0.5, 0.5);
        this.xBetReelFrame.position.set(65 + this.symbolWidth * 1.5, 327);
        this.xBetReelFrame.alpha = 0;
        this.addChild(this.xBetReelFrame);

        // nice code reusage lol
        this.disableXBet();

        this.maxWinAnticipation = new TimelineSprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.MAX_WIN_ANTICIPATION));
        this.maxWinAnticipation.blendMode = PIXI.BLEND_MODES.ADD;
        this.maxWinAnticipation.scale.set(2,2);
        this.maxWinAnticipation.anchor.set(0.5, 0.5);
        this.maxWinAnticipation.position.set(360, 0);
        this.maxWinAnticipation.hide();
        this.addChild(this.maxWinAnticipation);
        this.maxWinAnticipation2 = new TimelineSprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.MAX_WIN_ANTICIPATION));
        this.maxWinAnticipation2.blendMode = PIXI.BLEND_MODES.ADD;
        this.maxWinAnticipation2.scale.set(2,2);
        this.maxWinAnticipation2.anchor.set(0.5, 0.5);
        this.maxWinAnticipation2.position.set(360, 0);
        this.maxWinAnticipation2.hide();
        this.addChild(this.maxWinAnticipation2);

        this.wallExplosion = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.SNAKE_FX));
        this.wallExplosion.alpha = 0;
        this.addChild(this.wallExplosion);
        this.wallExplosion2 = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.SNAKE_FX));
        this.wallExplosion2.alpha = 0;
        this.addChild(this.wallExplosion2);
        this.explosions = new LoopableList([
            "Wall_FX_1",
            "Wall_FX_2",
            "Wall_FX_3",
            "Wall_FX_4",
            "Wall_FX_5",
            "Wall_FX_6",
        ]);
    }

    public enable() {
        this.visible = true;
    }

    public disable() {
        this.visible = false;
    }
    public doWallExplosion(from:reelPosition, to:reelPosition):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.wallExplosion.position.x  = 65  + from.reelID       * this.symbolWidth + this.symbolWidth  * 0.5;
                this.wallExplosion.position.y  = 150 + from.reelPosition * this.symbolHeight;
                this.wallExplosion2.position.x = 65  + to.reelID         * this.symbolWidth + this.symbolWidth  * 0.5;
                this.wallExplosion2.position.y = 150 + to.reelPosition   * this.symbolHeight;

                this.wallExplosion.alpha = 1;
                this.wallExplosion2.alpha = 1;

                if (from.reelID == to.reelID) {
                    if (from.reelPosition > to.reelPosition) {
                        this.wallExplosion.rotation = Math.PI * 1.5;
                        this.wallExplosion2.rotation = Math.PI * 0.5;
                    } else {
                        this.wallExplosion.rotation = Math.PI * 0.5;
                        this.wallExplosion2.rotation = Math.PI * 1.5;
                    }
                } else {
                    if (from.reelID > to.reelID) {
                        this.wallExplosion.rotation = Math.PI;
                        this.wallExplosion2.rotation = 0;
                    } else {
                        this.wallExplosion.rotation = 0
                        this.wallExplosion2.rotation = Math.PI;
                    }
                }
            })
            .add(SpineGSAPWrapper.createTimeline(this.wallExplosion, 0, this.explosions.next()))
            .add(SpineGSAPWrapper.createTimeline(this.wallExplosion2, 0, this.explosions.next()), '<')
            .add(() => {
                this.wallExplosion.state.setEmptyAnimation(0,0);
                this.wallExplosion.alpha = 0;
                this.wallExplosion2.state.setEmptyAnimation(0,0);
                this.wallExplosion2.alpha = 0;
            })
    }

    public startMaxWinAnticipation(row:number):gsap.core.Timeline {
        return gsap.timeline().add(() => {
            this.maxWinAnticipation.y = 35 + this.symbolHeight * row;
            this.maxWinAnticipation.show();
            this.maxWinAnticipation.playLoop();
            this.maxWinAnticipation2.y = 35 + this.symbolHeight * row;
            this.maxWinAnticipation2.show();
            this.maxWinAnticipation2.playLoop();
        });
    }

    public stopMaxWinAnticipation():gsap.core.Timeline {
        return gsap.timeline().add(() => {
            this.maxWinAnticipation.hide();
            this.maxWinAnticipation.stopLoop();
            this.maxWinAnticipation.setFrame(0);
            this.maxWinAnticipation2.hide();
            this.maxWinAnticipation2.stopLoop();
            this.maxWinAnticipation2.setFrame(0);
        });
    }

    public setBaseReelSet():void {
        this._reelModels.forEach((reel, index) => {
            reel.setReelSet( index == 0 ? BrickSnake2000BaseGameReelView.BASE_GAME_REEL_1 : BrickSnake2000BaseGameReelView.DEFAULT_REEL_SET);
        })
    }

    public setFreeSpinsReelSet():void {
        this._reelModels.forEach((reel) => {
            reel.setReelSet(BrickSnake2000BaseGameReelView.FREE_SPINS_REEL);
        })
    }

    private removeCurrentMask():void {
        this.layers.maskedNormal.removeChild(this.symbolMask);
        this.layers.maskedM1.removeChild(this.symbolMask);
        this.layers.maskedScatters.removeChild(this.symbolMask);
        this.layers.maskedOver.removeChild(this.symbolMask);
        this.layers.maskedWinCap.removeChild(this.symbolMask);
    }

    private setCurrentMask():void {
        this.layers.maskedNormal.addChild(this.symbolMask);
        this.layers.maskedNormal.mask = this.symbolMask;
        this.layers.maskedM1.addChild(this.symbolMask);
        this.layers.maskedM1.mask = this.symbolMask;
        this.layers.maskedScatters.addChild(this.symbolMask);
        this.layers.maskedScatters.mask = this.symbolMask;
        this.layers.maskedOver.addChild(this.symbolMask);
        this.layers.maskedOver.mask = this.symbolMask;
        this.layers.maskedWinCap.addChild(this.symbolMask);
        this.layers.maskedWinCap.mask = this.symbolMask;
    }

    public enableXBet():void {
        this.removeCurrentMask();
        this.symbolMask = new PIXI.Graphics();
        this.symbolMask.beginFill();
        this.symbolMask.drawRect(-6 - 16, -59, this.symbolWidth * 5 + 12 + 32, this.symbolHeight * 4);
        this.xBetDisabledRow.forEach((sym) => sym.alpha = 1);
        this.setCurrentMask();
        this.xBetReelHighlight.alpha = 1;
        this.xBetReelFrame.alpha = 1;
    }

    public disableXBet():void {
        this.removeCurrentMask();
        this.symbolMask = new PIXI.Graphics();
        this.symbolMask.beginFill();
        this.symbolMask.drawRect(-6 - 16, -59, this.symbolWidth * 5 + 12 + 32, this.symbolHeight * 5);
        this.xBetDisabledRow.forEach((sym) => sym.alpha = 0);
        this.setCurrentMask();
        this.xBetReelHighlight.alpha = 0;
        this.xBetReelFrame.alpha = 0;
    }

    createSymbol(symbolName:string, state:SimpleReelModelState, reelID:number, position:number):BrickSnake2000Symbol {
        // god I love hackjobs
        const isFSRestore =  BrickSnake2000.model.isRestore && (BrickSnake2000.model.data.mode == GameMode.FREESPIN ||
                                                                BrickSnake2000.model.data.mode == GameMode.FREESPIN_SUPER );
        const symbolSize = isFSRestore
                           ? BrickSnake2000.model.initData.symbolSizesEnteringFS[reelID][position]
                           : BrickSnake2000.model.data.symbolSizes != undefined
                             ? BrickSnake2000.model.data.symbolSizes[reelID][position]
                             : 1;
        const symbol = BrickSnake2000.symbolFactory.createSymbol( {
                symbolName: symbolName,
                isSpinning: state == SimpleReelModelState.SPIN,
                isStopping: state == SimpleReelModelState.STOP,
                reelsView: this,
                reelPosition: position,
                reelID: reelID,
                symbolSize: symbolSize
            });
        symbol.position.x = reelID * this.symbolWidth + this.symbolWidth*0.5;
        return symbol;
    }
    
    removeSymbol(symbolData:BrickSnake2000Symbol):void {
        symbolData.destroy();
    }

    getAllSymbols():BrickSnake2000Symbol[] {
        return <BrickSnake2000Symbol[]>this._reelModels
            .map((reel) => reel.getAllVisibleSymbols())
            .reduce((a,b) => a.concat(b), []);
    }

    getAllSymbolsActually():BrickSnake2000Symbol[] {
        return <BrickSnake2000Symbol[]>this._reelModels
            .map((reel) => reel.getAllSymbols())
            .reduce((a,b) => a.concat(b), []);
    }

    getSymbolAt(column:number, row:number) {
        return this.reelModels[column].symbols.find((sym) => sym.reelPosition == row)!;
    }

    setSymbolAt(column:number, row:number, newSym:BrickSnake2000Symbol) {
        this.reelModels[column].replaceSymbolAt(row, newSym);
        newSym.reelID = column;
        newSym.reelPosition = row;
        newSym.position.x = column * this.symbolWidth + this.symbolWidth*0.5;
        newSym.position.y = this.symbolHeight * row;
    }

    replaceSymbolAt(column: number, row: number, newSym:BrickSnake2000Symbol):void {
        const oldSymbol = this.getSymbolAt(column, row);
        this.setSymbolAt(column, row, newSym)
        this.removeSymbol(oldSymbol);
    }
}